var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 13.6777L12.7354 11.6908V7.64359C12.7354 7.23665 12.4065 6.90771 11.9996 6.90771C11.5926 6.90771 11.2637 7.23665 11.2637 7.64359V12.0588C11.2637 12.2906 11.3726 12.5092 11.558 12.6475L14.5015 14.8551C14.6285 14.9508 14.7832 15.0024 14.9422 15.0023C15.1667 15.0023 15.3875 14.9014 15.5317 14.7072C15.7761 14.3826 15.7098 13.9212 15.3846 13.6777Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.76138 2.5 2.5 6.76138 2.5 12C2.5 17.2386 6.76138 21.5 12 21.5C17.2386 21.5 21.5 17.2386 21.5 12C21.5 6.76138 17.2386 2.5 12 2.5ZM12 20.0283C7.57378 20.0283 3.97172 16.4262 3.97172 12C3.97172 7.57378 7.57378 3.97172 12 3.97172C16.427 3.97172 20.0283 7.57378 20.0283 12C20.0283 16.4262 16.4262 20.0283 12 20.0283Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.53a9b64860a026cd66f145748c4ef556.svg";
export { ForwardRef as ReactComponent };